
import axios from "axios";


import { useDispatch, useSelector } from "react-redux";

import { FaPhoneFlip } from "react-icons/fa6";

import { stepsData } from "@/types/globalTypes";
import { MdOutlineInsertEmoticon } from "react-icons/md";
import { GiShop } from "react-icons/gi";
import { IoRestaurant } from "react-icons/io5";
import { BsClipboardData } from "react-icons/bs";
import { GrDomain } from "react-icons/gr";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";


import { useTranslation } from "react-i18next";
import YoutubePlayer from "@/components/YoutubePlayer";
import { useState } from "react";
import useLockBodyScroll from "@/hooks/useLockBodyScroll";
import { navigateToSubscribtion } from "@/utils/helpers";
import { X } from "lucide-react";
import { rerenderLayout } from "@/store/RenderProtectionRoute.slice";

interface DashboardStepsProps {
    stepsData: stepsData;
    getStepsStatus: () => void;
    showAllStatus: boolean;
}

export default function DashboardSteps({ stepsData, getStepsStatus }: DashboardStepsProps) {
    const { t, i18n } = useTranslation();
    const baseUrl = import.meta.env.VITE_BASE_URL
    const token = useSelector((state: { auth: { token: string } }) => state.auth.token);
    const [hasSubscriptionModal, setHasSubscriptionModal] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    function toggleSubscriptionModal() {
        setHasSubscriptionModal(!hasSubscriptionModal)
    }
    useLockBodyScroll(hasSubscriptionModal)
    function readyCheck() {

        if (stepsData?.hasBranch === true && stepsData?.hasLogo === true && stepsData?.hasName === true && stepsData?.hasPhone === true && stepsData?.hasProduct === true && stepsData?.hasDomain === true && stepsData?.hasSubscription === true) {
            return true
        } else {
            return false
        }
    }
    async function publishMenu() {
        const toastId = toast.loading(t("Dashboard.Publishing") as string)
        try {
            const response = await axios.post(`${baseUrl}/api/dashboard/settings/restaurant/publish?locale=${i18n.language}`, {
                published: true
            }, {
                headers: {
                    Authorization: token,
                },
            });

            if (response.data.success === true) {
                toast.success(t("Dashboard.Published") as string)
                getStepsStatus()
                dispatch(rerenderLayout())
            }
        } catch (error) {
            if (axios.isAxiosError(error) && error.response) {

                toggleSubscriptionModal()
            } else {
                toast.error("An unexpected error occurred")
            }

        } finally {
            toast.dismiss(toastId)
        }
    }

    return (
        <>
            {hasSubscriptionModal && (
                <div className="fixed inset-0 z-[9999] bg-black/50 flex items-center justify-center px-4">
                    <div className="bg-white w-full max-w-md rounded-2xl flex flex-col shadow-xl p-6 relative">
                        {/* Close button */}
                        <button
                            onClick={toggleSubscriptionModal}
                            className="self-end"
                        >
                            <X className="w-5 h-5 text-red-500" />
                        </button>

                        <div className="text-center space-y-4">
                            <h2 className="text-xl font-bold text-sidebar">{t("subscribeModal.title")}</h2>
                            <p className="text-gray-600">{t("subscribeModal.description")}</p>

                            <button
                                onClick={() => navigateToSubscribtion(navigate, token)}
                                className="mt-4 bg-skyblue text-sidebar font-semibold px-6 py-2 rounded-lg hover:opacity-90"
                            >
                                {t("subscribeModal.button")}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <h2 className="flex items-center gap-2 text-2xl font-bold text-sidebar">
                {t("gettingStartedSteps")}
                <div>
                    <img src="https://www.svgrepo.com/show/275999/rocket.svg" className="w-[20px]" alt="" />
                </div>
            </h2>

            <div className="grid gap-y-6 gap-x-10 mt-10 xl:grid-cols-8">
                {/* LEFT SIDE: Steps or Publish Button */}
                <div className="xl:col-span-5 w-full">
                    {!readyCheck() ? (
                        <div className="grid gap-5 grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3">
                            {!stepsData?.hasBranch && (
                                <div className="bg-white border h-fit p-5 relative rounded-lg flex flex-col gap-8">
                                    <span className="absolute end-5 top-2 text-[12px] font-bold text-sidebar">
                                        {t("justAMoment")}
                                    </span>
                                    <div className="flex flex-col gap-2 text-lg">
                                        <span className="text-2xl rounded-lg bg-sidebar text-skyblue w-fit p-2">
                                            <BsClipboardData />
                                        </span>
                                        <span className="text-sidebar font-bold">{t("addBranchDetails")}</span>
                                    </div>
                                    <div>
                                        <Link
                                            to="/settings/branches-settings"
                                            className="w-fit whitespace-nowrap text-sm bg-skyblue text-sidebar px-5 py-1 rounded-lg font-semibold"
                                        >
                                            {t("addBranch")}
                                        </Link>
                                    </div>
                                </div>
                            )}

                            {!stepsData?.hasPhone && (
                                <div className="bg-white border h-fit p-5 relative rounded-lg flex flex-col gap-8">
                                    <span className="absolute end-5 top-2 text-[12px] font-bold text-sidebar">
                                        {t("justAMoment")}
                                    </span>
                                    <div className="flex flex-col gap-2 text-lg">
                                        <span className="text-2xl rounded-lg bg-sidebar text-skyblue w-fit p-2">
                                            <FaPhoneFlip />
                                        </span>
                                        <span className="text-sidebar font-bold">{t("addYourPhoneNumber")}</span>
                                    </div>
                                    <div>
                                        <Link
                                            to="/settings/general-settings"
                                            className="w-fit whitespace-nowrap text-sm bg-skyblue text-sidebar px-5 py-1 rounded-lg font-semibold"
                                        >
                                            {t("addNumber")}
                                        </Link>
                                    </div>
                                </div>
                            )}

                            {!stepsData?.hasLogo && (
                                <div className="bg-white border h-fit p-5 relative rounded-lg flex flex-col gap-8">
                                    <span className="absolute end-5 top-2 text-[12px] font-bold text-sidebar">
                                        {t("justAMoment")}
                                    </span>
                                    <div className="flex flex-col gap-2 text-lg">
                                        <span className="text-2xl rounded-lg bg-sidebar text-skyblue w-fit p-2">
                                            <MdOutlineInsertEmoticon />
                                        </span>
                                        <span className="text-sidebar font-bold">{t("addYourIcon")}</span>
                                    </div>
                                    <div>
                                        <Link
                                            to="/settings/general-settings"
                                            className="w-fit whitespace-nowrap text-sm bg-skyblue text-sidebar px-5 py-1 rounded-lg font-semibold"
                                        >
                                            {t("addLogo")}
                                        </Link>
                                    </div>
                                </div>
                            )}

                            {!stepsData?.hasProduct && (
                                <div className="bg-white border h-fit p-5 relative rounded-lg flex flex-col gap-8">
                                    <span className="absolute end-5 top-2 text-[12px] font-bold text-sidebar">
                                        {t("justAMoment")}
                                    </span>
                                    <div className="flex flex-col gap-2 text-lg">
                                        <span className="text-2xl rounded-lg bg-sidebar text-skyblue w-fit p-2">
                                            <IoRestaurant />
                                        </span>
                                        <span className="text-sidebar font-bold">{t("addAtleastOneProduct")}</span>
                                    </div>
                                    <div>
                                        <Link
                                            to="/products"
                                            className="w-fit whitespace-nowrap text-sm bg-skyblue text-sidebar px-5 py-1 rounded-lg font-semibold"
                                        >
                                            {t("addProduct")}
                                        </Link>
                                    </div>
                                </div>
                            )}

                            {!stepsData?.hasName && (
                                <div className="bg-white border h-fit p-5 relative rounded-lg flex flex-col gap-8">
                                    <span className="absolute end-5 top-2 text-[12px] font-bold text-sidebar">
                                        {t("justAMoment")}
                                    </span>
                                    <div className="flex flex-col gap-2 text-lg">
                                        <span className="text-2xl rounded-lg bg-sidebar text-skyblue w-fit p-2">
                                            <GiShop />
                                        </span>
                                        <span className="text-sidebar font-bold">{t("addRestaurantName")}</span>
                                    </div>
                                    <div>
                                        <Link
                                            to="/settings/general-settings"
                                            className="w-fit whitespace-nowrap text-sm bg-skyblue text-sidebar px-5 py-1 rounded-lg font-semibold"
                                        >
                                            {t("addRestaurantName")}
                                        </Link>
                                    </div>
                                </div>
                            )}

                            {!stepsData?.hasDomain && (
                                <div className="bg-white border h-fit p-5 relative rounded-lg flex flex-col gap-8">
                                    <span className="absolute end-5 top-2 text-[12px] font-bold text-sidebar">
                                        {t("justAMoment")}
                                    </span>
                                    <div className="flex flex-col gap-2 text-lg">
                                        <span className="text-2xl rounded-lg bg-sidebar text-skyblue w-fit p-2">
                                            <GrDomain />
                                        </span>
                                        <span className="text-sidebar font-bold">{t("addDomain")}</span>
                                    </div>
                                    <div>
                                        <Link
                                            to="/settings/domain-settings"
                                            className="w-fit whitespace-nowrap text-sm bg-skyblue text-sidebar px-5 py-1 rounded-lg font-semibold"
                                        >
                                            {t("addDomain")}
                                        </Link>
                                    </div>
                                </div>
                            )}
                        </div>
                    ) : (
                        <div

                            className="mt-5 flex-wrap md:flex-nowrap md:justify-between bg-skyblue  px-5 py-5 rounded-md  flex justify-center gap-5 text-center items-center text-sidebar border-2 border-sidebar"
                        >
                            {t("readyToPublish")}
                            <button
                                onClick={publishMenu}
                                className="text-skyblue bg-sidebar p-2 text-nowrap rounded-lg">
                                {t("publishMenu")}
                            </button>
                        </div>
                    )}
                </div>

                {/* RIGHT SIDE: Video (Always Visible) */}
                <div className="xl:col-span-3 flex flex-col gap-5 items-center w-full">
                    <div className="overflow-hidden w-[90%] h-[300px] xl:w-[370px] xl:h-[300px] rounded-md">
                        <YoutubePlayer />
                    </div>
                    <p className="text-center font-bold text-sidebar">{t("videoExplainingSteps")}</p>
                </div>
            </div>
        </>

    )
}
